import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Alert } from '@televet/kibble-ui/Alert';
import { Heading } from '@televet/kibble-ui/Heading';
import { Spinner } from '@televet/kibble-ui/Spinner';
import { Text } from '@televet/kibble-ui/Text';
import { Flex } from '@televet/kibble-ui/chakra';
import { PageContainer } from '@/components/PageContainer';
import { Breadcrumbs } from '@/components/Breadcrumbs';
import { trpc } from '@/lib/trpc';
import { STATUS_REFRESH_MS } from './-lib/backfillFormat';
import { BackfillLaneTable } from './-components/BackfillLaneTable';
import { BackfillRequestHistory } from './-components/BackfillRequestHistory';

export const Route = createFileRoute('/_authenticated/emitters/backfills/$label')({
  component: BackfillDetail,
});

function BackfillDetail() {
  const { label } = Route.useParams();
  const { data: lanes, error } = useQuery(
    trpc.emitter.getBackfill.queryOptions({ label }, { refetchInterval: STATUS_REFRESH_MS })
  );

  return (
    <PageContainer>
      <Flex direction="column" w="100%" gap={4}>
        <Breadcrumbs items={[{ label: 'Backfills', to: '/emitters/backfills' }, { label }]} />
        <Heading size="lg">Backfill {label}</Heading>
        <Text variant="subtle">
          Refreshes every 15 seconds. Pause or archive a lane from its instance page.
        </Text>
        {error && (
          <Alert
            status="error"
            hideCloseButton
            title="Could not load lanes"
            description={error.message}
          />
        )}
        {!lanes && !error && <Spinner size="sm" />}
        {lanes && <BackfillLaneTable label={label} lanes={lanes} />}
        <Heading size="sm">Requests</Heading>
        <BackfillRequestHistory label={label} />
      </Flex>
    </PageContainer>
  );
}
